<template>
	<div class='step'>

		<ActionHandler v-if='show_action' @complete="complete_action" @failure="failure" @clear="clear_action" />

		<LoadingScreen header='Please wait...' :message='loading_message' v-if='loading_message !== undefined && loading_message.length > 0'/>

		<ReviewScreen v-model='accept_terms' />

		<ErrorMessage :message="error_message" v-if='error_message !== undefined && error_message.length > 0' />
		<WarningMessage :message="warning_message" v-if='warning_message !== undefined && warning_message.length > 0' />

		<div class='button-box'>
			<div class='row'>
				<div class='col-xs-12 col-lg-4 order-2 order-lg-1'>
					<a class='start-over' @click="clear()">{{getText('StartOver')}}</a>
				</div>
				<div class='col-xs-12 col-lg-4 order-3 order-lg-2'>
					<div class='contact-text'>
						<b>{{getText('NeedHelp')}}</b> <a class='support-link' :href='"mailto:"+merchant().SupportEmail'>{{merchant().SupportEmail}}</a>
					</div>
				</div>
				<div class='col-xs-12 col-lg-4 order-1 order-lg-3'>
					<input class='submit-button' readonly :value="getText('PayNow')" @click="validate()" >
				</div>
			</div>
		</div>

	</div>
</template>


<script>

import { mapGetters } from "vuex";
import store from "@/store";
import { CheckoutService, GeneralService } from "@/common/api.service";

import {
	CHECKOUT,
	VALIDATE_PACKAGE
} from "@/store/actions.type";
import {
	SET_ACTION,
	SET_ORDER_ID
} from "@/store/mutations.type";

// Language / Localization
import LanguageService from "@/common/language.service";

// Import Major components
import ReviewScreen from "@/components/steps/review_step/ReviewScreen";
import LoadingScreen from "@/components/general/LoadingScreen";
import ActionHandler from "@/components/general/ActionHandler";
import Badge from "@/components/general/Badge";

/* Smaller elements */
import WarningMessage from "@/components/messages/WarningMessage";
import ErrorMessage from "@/components/messages/ErrorMessage";

export default {
	name: "ReviewStep",
	components: {
		ReviewScreen,
		ActionHandler,
		Badge,
		LoadingScreen,

		WarningMessage,
		ErrorMessage,
	},
	data() {
		// Our primary data objects (used to store user data and progress)
		return {
			error_message: "",
			warning_message: "",
			loading_message: "",
			accept_terms: false,
			show_action: false
		}
	},
	computed: {},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
		getError(key){
			return LanguageService.getError(key);
		},
		clear: function(){
			this.$emit('start_over', true);
		},
		clear_action: function(){
			this.show_action = false;
		},
		failure: function(data){
			this.error_message = data;
			this.show_action = false;
			this.loading_message = "";
			store.commit(SET_ACTION, {});
		},
		complete_action: function(data){
			// Redirect to orderId
			this.$emit('success', this.order_id());
		},
		validate: function(){
			this.error_message = '';
			this.warning_message = '';

			if(!this.accept_terms){
				this.warning_message = this.getError('AcceptTerms');//;
				return;
			}

			this.loading_message = this.getText('PaymentProcessing');

			// RUN OUR CHECKOUT
			$(window).scrollTop(0);
			store.dispatch(CHECKOUT).then(data => this.handle_checkout_result(data))
			.catch(error => {
				$(window).scrollTop(9999);
				if(error) this.error_message = error;
				else this.error_message = this.getError('ServerError');
				this.loading_message = '';
			});
		},
		handle_checkout_result: function(data){
			try{
				var query = parseQuery(data.data);

				var url_data = {
					package: query.response,
					signature: query.signature
				};

				// First, Validate the package
				store.dispatch(VALIDATE_PACKAGE, url_data).then(data => {
					this.error_message = '';
					this.warning_message = '';

					if(!data.valid) {
						$(window).scrollTop(9999);
						this.loading_message = '';
						throw this.getError('ServerError');
						return;
					}

					// Signed package is valid - process it
					var response = JSON.parse(query.response);

					// Handle errors
					if(response.Error !== undefined) {
						// Return error from code or backup error
						if(response.Error.Code !== undefined && response.Error.Code.length > 0){
							this.error_message = this.getError(response.Error.Code);
						} else {
							this.error_message = this.getError('UnknownError');
						}
						$(window).scrollTop(9999);
						this.loading_message = '';
						return;
					}

					// Store the OrderId for later
					store.commit(SET_ORDER_ID, response.OrderId);

					// If we require further action, display it!
					if(response.Action !== undefined){
						store.commit(SET_ACTION, response.Action);
						this.show_action = true;
						return;
					}

					// Otherwise, forward user off to orderId
					this.$emit('success', response.OrderId);
				}).catch(error => {
					$(window).scrollTop(9999);
					this.loading_message = '';
					this.error_message = this.getError('ServerError');
					throw this.getError('ServerError');
					return;
				});
			}catch(err){
				$(window).scrollTop(9999);
				this.loading_message = '';
				this.error_message = this.getError('ServerError');
				throw this.getError('ServerError');
				return;
			}
		},
		...mapGetters(["billing", "merchant", "payment_method", "payment_details", "invoice", "rateOffer", "payload", "action", "order_id"])
	}
}
</script>
